export const WIDGETS_API_VERSION = "1";
//# sourceMappingURL=constants.js.map